import { inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from "@angular/router";
import { GuardReturnType } from "./util";
import { firstValueFrom } from "rxjs";
import { CALLING_CODE_KEY_IN_STORAGE, COUNTRY_KEY_IN_STORAGE } from "../common/countries";
import { IpApiService } from "../../core/service/ip-api.service";

@Injectable({ providedIn: 'root' })
export class CountryGuard implements CanActivate {
  private ipApiService = inject(IpApiService);

  async canActivate(activatedRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): GuardReturnType {
    await this.initCountry();
    return true;
  }

  private async initCountry(): Promise<void> {
    const countryFromStorage = localStorage.getItem(COUNTRY_KEY_IN_STORAGE);
    const callingCodeFromStorage = localStorage.getItem(CALLING_CODE_KEY_IN_STORAGE);
    if (!countryFromStorage || countryFromStorage === 'null' ||
      !callingCodeFromStorage || callingCodeFromStorage === 'null') {
      const locationData = await firstValueFrom(this.ipApiService.getCountryName());
      localStorage.setItem(COUNTRY_KEY_IN_STORAGE, locationData?.country || '');
      localStorage.setItem(CALLING_CODE_KEY_IN_STORAGE, locationData?.callingCode?.replace('+', '') || '');
    }
  }
}
